import classNames from 'classnames'

const TrademarkText = ({ children, className }) => (
  <span className={classNames('trademark-text', className)}>{children}</span>
)

export default TrademarkText
